import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";

const KEY = "pc_cookie_consent";

// Banner informativo conforme alle Linee guida cookie del Garante (10/06/2021):
// l'app usa solo cookie tecnici/di sessione (nessuna profilazione), con pari
// evidenza tra accettazione e rifiuto e link alla cookie policy.
export default function CookieConsent() {
  const { tr } = useLang();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setOpen(true); } catch (e) { /* ignore */ }
    const reopen = () => setOpen(true);
    window.addEventListener("open-cookie-preferences", reopen);
    return () => window.removeEventListener("open-cookie-preferences", reopen);
  }, []);

  const choose = (choice) => {
    try { localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() })); } catch (e) { /* ignore */ }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-[120] p-3 sm:p-4">
      <div className="max-w-4xl mx-auto bg-card border border-border rounded-sm shadow-2xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={26} weight="fill" className="text-primary shrink-0 mt-0.5" />
          <p className="text-sm text-muted-foreground leading-relaxed">
            {tr(
              "Usiamo esclusivamente cookie tecnici e di sessione, necessari al funzionamento e all'autenticazione. Non utilizziamo cookie di profilazione né di marketing di terze parti.",
              "We only use essential technical and session cookies, required for the service to work and for authentication. We do not use profiling or third-party marketing cookies."
            )}{" "}
            <Link to="/cookie" className="text-primary underline underline-offset-2" data-testid="cookie-policy-link">
              {tr("Cookie policy", "Cookie policy")}
            </Link>
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button variant="secondary" data-testid="cookie-reject" onClick={() => choose("rejected")} className="font-display uppercase tracking-wide">
            {tr("Rifiuta", "Reject")}
          </Button>
          <Button data-testid="cookie-accept" onClick={() => choose("accepted")} className="font-display uppercase tracking-wide">
            {tr("Accetta", "Accept")}
          </Button>
        </div>
      </div>
    </div>
  );
}
